module.exports = __webpack_public_path__ + "static/rezydencja-centrum-4947b4d46224e8280dfe6d67767aba33.png";